import { render, staticRenderFns } from "./WaterBalanceDma.vue?vue&type=template&id=9e63dcec&scoped=true&"
import script from "./WaterBalanceDma.vue?vue&type=script&lang=js&"
export * from "./WaterBalanceDma.vue?vue&type=script&lang=js&"
import style0 from "./WaterBalanceDma.vue?vue&type=style&index=0&id=9e63dcec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e63dcec",
  null
  
)

export default component.exports